#import "../../../../../graphql/fragments/peep-tag-maps-fragment.graphql"
#import "../../../../../graphql/fragments/creator-user-fragment.graphql"

fragment ContactSummaryFragment on Contact {
    id
    createdTime
    territory {
        id
        name
    }
    creatorUser {
        ...CreatorUserFragment
    }
    ...PeepTagMapsFragment
}
